import { useMutation } from "@apollo/client/react";import React, { memo, useState, useMemo } from 'react';

import { CustomButton } from '../../../../../components/customButton/CustomButton';
import { RenderInputByTypeMobile } from '../../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { CustomDialog } from '../../../../../components/customDialog/CustomDialog';
import toast from 'react-hot-toast';
import { RECHAZAR_CAPA } from '../../../../../data/graphQL/mutations/Capa/RechazarCapa';
import { DESESTIMAR_CAPA } from '../../../../../data/graphQL/mutations/Capa/DesestimarCapa';
import { useNavigate } from 'react-router-dom';

const PENDIENTE_CREADOR = 1;
const PENDIENTE_PRIMERA_REVISION = 2;
const PENDIENTE_SEGUNDA_REVISION = 3;
const PENDIENTE_PRORROGA = 4;
const PENDIENTE_APROBACION_FINAL = 5;

const etapasPuedeDesestimar = {
  [PENDIENTE_CREADOR]: false,
  [PENDIENTE_PRIMERA_REVISION]: true,
  [PENDIENTE_SEGUNDA_REVISION]: false,
  [PENDIENTE_PRORROGA]: false,
  [PENDIENTE_APROBACION_FINAL]: false
};

const etapasPuedeRechazar = {
  [PENDIENTE_CREADOR]: false,
  [PENDIENTE_PRIMERA_REVISION]: true,
  [PENDIENTE_SEGUNDA_REVISION]: false,
  [PENDIENTE_PRORROGA]: true,
  [PENDIENTE_APROBACION_FINAL]: false
};

const RechazoModal = memo(({
  isRechazoParcial,
  disabled,
  idGestionCapa,
  idEtapa,
  allowedWrite
}) => {
  const [rechazoDescripcion, setRechazoDescripcion] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const [rechazarCapa, { loading: rechazarLoading }] = useMutation(RECHAZAR_CAPA, {
    onCompleted: () => {
      toast.success('Capa rechazada con éxito');
    }
  });

  const [desestimarCapa, { loading: desestimarLoading }] = useMutation(DESESTIMAR_CAPA, {
    onCompleted: () => {
      toast.success('Capa desestimada con éxito');
    }
  });

  const onSubmit = () => {

    if (!rechazoDescripcion?.trim()) return toast.error('Es necesario cargar una descripción.');

    if (isRechazoParcial) {
      rechazarCapa({
        variables: {
          input: {
            idGestionCapa: idGestionCapa,
            justificacion: rechazoDescripcion
          }
        }
      });
    } else {
      desestimarCapa({
        variables: {
          input: {
            idGestionCapa: idGestionCapa,
            justificacion: rechazoDescripcion
          }
        }
      });
    }
    handleCloseModal();
    setTimeout(() => navigate('/calidad/capas'), 1000);
  };

  const buttonActionLoading = useMemo(() =>
  desestimarLoading ||
  rechazarLoading,
  [
  desestimarLoading,
  rechazarLoading]
  );

  return (
    <>
            <CustomButton
        label={isRechazoParcial ? 'Rechazo' : 'Desestimar'}
        loading={buttonActionLoading}
        disabled={disabled || (isRechazoParcial ? !etapasPuedeRechazar[idEtapa] : !etapasPuedeDesestimar[idEtapa])}
        onClick={handleOpenModal}
        variant='outlined' />
      
            <CustomDialog
        open={openModal}
        title={isRechazoParcial ? 'Rechazo' : 'Desestimar'}
        acceptText='Enviar'
        onAccept={onSubmit}
        cancelText='Cerrar'
        onCancel={handleCloseModal}
        fullWidth>
        
                <RenderInputByTypeMobile
          input={{
            name: 'rechazoDescripcion',
            type: 'long_string',
            displayName: isRechazoParcial ?
            'Justificación de Rechazo' :
            'Justificación Desestimación',
            required: true
          }}
          handleChange={(_, value) => setRechazoDescripcion(value)}
          value={rechazoDescripcion} />
        
            </CustomDialog>
        </>);

});

export default RechazoModal;